import { Kontent_Item_Multiple_Choice_Element } from "../../graphql-types";

export const pageConfig = (
  settings: Pick<Kontent_Item_Multiple_Choice_Element, "codename">[]
) => ({
  isStandaloneHeader: settings.some(
    ({ codename }) => codename === "standalone_header"
  ),
  isStandaloneFooter: settings.some(
    ({ codename }) => codename === "standalone_footer"
  ),
  noIndex: settings.some(({ codename }) => codename === "noindex")
});

export default pageConfig;
